// Mapeo de la selección de la UI (con mayúsculas) al valor que se guardará en la BD (en minúsculas)
export const uiToDbType = {
  "Correr": "correr",
  "Ciclismo": "ciclismo",
  "Nadar": "nadar",
  "Descanso": "descanso",
  "Fuerza": "fuerza",
  "Caminar": "caminar",
  "Otro": "otro"
};

// Mapeo del valor almacenado en la BD al URL del ícono correspondiente
export const dbTypeToIcon = {
  "correr": "/static/media/running.png",
  "ciclismo": "/static/media/cycling.png",
  "nadar": "/static/media/swim.png",
  "descanso": "/static/media/dayoff.png",
  "fuerza": "/static/media/strength.png",
  "caminar": "/static/media/walk.png",
  "otro": "/static/media/other.png"
};
